import { formatarDataBr } from '@/utils/date'
import { labelPeriodoSemana } from '@/utils/sprintGestao'

export const STORAGE_VERSION = 1
export const IMAGEM_MAX_BYTES = 2 * 1024 * 1024
export const IMAGEM_TIPOS_PERMITIDOS = ['image/png', 'image/jpeg', 'image/webp']

export const COLUNAS_TABELA_PADRAO = [
    'pcm_codigo',
    'projeto_nome',
    'entrega_nome',
    'gerente_nome',
    'fim_previsto',
    'entrega_status',
]

export const COLUNAS_PROJETO_PADRAO = [
    'pcm_codigo',
    'projeto_nome',
    'gerente_nome',
    'projeto_status',
]

export const CATALOGO_COLUNAS = {
    pcm_codigo: { label: 'Código PCM', grupo: 'entrega' },
    projeto_nome: { label: 'Nome do projeto', grupo: 'entrega' },
    projeto_status: { label: 'Status do projeto', grupo: 'entrega' },
    gerente_nome: { label: 'Gerente do projeto', grupo: 'entrega' },
    entrega_nome: { label: 'Pacote de trabalho', grupo: 'entrega' },
    coordenador_nome: { label: 'Coordenador do pacote de trabalho', grupo: 'entrega' },
    fim_previsto: { label: 'Fim previsto', grupo: 'entrega', formatar: 'data' },
    entrega_status: { label: 'Status do pacote de trabalho', grupo: 'entrega' },
    resultado_ser_alcancado: { label: 'Entrega a ser alcançada', grupo: 'entrega' },
    observacao: { label: 'Observação', grupo: 'entrega' },
    pcm_nivel: { label: 'Nível PCM', grupo: 'entrega' },
    projeto_estrategico: { label: 'Estratégico', grupo: 'entrega', formatar: 'boolean' },
    dt_inicio: { label: 'Início do pacote de trabalho', grupo: 'entrega', formatar: 'data' },
    dt_conclusao: { label: 'Conclusão', grupo: 'entrega', formatar: 'data' },
    nome: { label: 'Nome do projeto', grupo: 'projeto' },
    status: { label: 'Status do projeto', grupo: 'projeto' },
    dtInicio: { label: 'Data de início', grupo: 'projeto', formatar: 'data' },
    dtTermino: { label: 'Data de término', grupo: 'projeto', formatar: 'data' },
    setor: { label: 'Setor', grupo: 'projeto' },
}

export function chaveStorageApresentacao(userId) {
    const id = Number(userId)
    if (!Number.isFinite(id) || id <= 0) return 'gestao-entregas-apresentacao-v1-anon'
    return `gestao-entregas-apresentacao-v1-${id}`
}

export function gerarSlideId() {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
        return crypto.randomUUID()
    }
    return `slide-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`
}

export function labelColuna(campo) {
    return CATALOGO_COLUNAS[campo]?.label || campo
}

const CAMPOS_COLUNA_ENTREGA = [
    'entrega_nome', 'coordenador_nome', 'fim_previsto', 'entrega_status',
    'resultado_ser_alcancado', 'observacao', 'dt_inicio', 'dt_conclusao', 'pcm_nivel', 'projeto_estrategico',
]

export function colunasPrecisamEntrega(colunas = []) {
    return colunas.some((c) => CAMPOS_COLUNA_ENTREGA.includes(c))
}

export function criarSlideVazio(tipo, overrides = {}) {
    const base = {
        id: gerarSlideId(),
        tipo,
        titulo: '',
        subtitulo: '',
        corpo: '',
        fonte: 'manual',
        fonteDados: 'entregas-periodo',
        colunas: [...COLUNAS_PROJETO_PADRAO],
        projetoIds: [],
        itensManuais: [],
        imagemDataUrl: '',
        imagemLegenda: '',
        imagemAjuste: 'contain',
    }
    return normalizarSlideManual({ ...base, ...overrides, id: overrides.id || base.id })
}

export function criarItemManual(projetoId, entregaId = null) {
    return {
        id: gerarSlideId(),
        projeto_id: Number(projetoId),
        entrega_id: entregaId != null ? Number(entregaId) : null,
    }
}

export function sincronizarProjetoIdsSlide(slide) {
    if (!slide || slide.tipo !== 'tabela') return slide
    const itens = slide.itensManuais || []
    slide.projetoIds = [...new Set(itens.map((i) => Number(i.projeto_id)).filter((id) => id > 0))]
    return slide
}

export function obterItensManuaisSlide(slide) {
    if (!slide || slide.tipo !== 'tabela' || slide.fonte !== 'manual') return []
    if (Array.isArray(slide.itensManuais)) return slide.itensManuais
    return (slide.projetoIds || []).map((pid) => ({
        id: `legacy-${Number(pid)}`,
        projeto_id: Number(pid),
        entrega_id: null,
    }))
}

export function normalizarSlideManual(slide) {
    if (!slide || slide.tipo !== 'tabela' || slide.fonte !== 'manual') return slide

    if (!Array.isArray(slide.itensManuais)) {
        slide.itensManuais = (slide.projetoIds || []).map((pid) => criarItemManual(pid, null))
    } else {
        slide.itensManuais = slide.itensManuais.map((item) => ({
            id: item.id || gerarSlideId(),
            projeto_id: Number(item.projeto_id),
            entrega_id: item.entrega_id != null ? Number(item.entrega_id) : null,
        }))
    }

    return sincronizarProjetoIdsSlide(slide)
}

export function normalizarSlidesApresentacao(slides = []) {
    return slides.map((slide) => normalizarSlideManual({ ...slide }))
}

export function criarSlidesPadrao({ periodoInicio, periodoFim } = {}) {
    const periodo = labelPeriodoSemana(periodoInicio, periodoFim)
    const hoje = new Date()
    const dataFormatada = formatarDataBr(hoje.toISOString().slice(0, 10))

    return [
        criarSlideVazio('capa', {
            titulo: 'Revisão Executiva de Prioridades',
            subtitulo: periodo || dataFormatada,
            fonte: 'dinamica',
        }),
        criarSlideVazio('tabela', {
            titulo: 'Pacotes de trabalho no período',
            fonte: 'dinamica',
            fonteDados: 'entregas-periodo',
            colunas: [...COLUNAS_TABELA_PADRAO],
        }),
        criarSlideVazio('tabela', {
            titulo: 'Pacotes de trabalho atrasados',
            fonte: 'dinamica',
            fonteDados: 'atrasadas',
            colunas: [...COLUNAS_TABELA_PADRAO],
        }),
        criarSlideVazio('tabela', {
            titulo: 'Pacotes de trabalho fixados',
            fonte: 'dinamica',
            fonteDados: 'fixadas',
            colunas: [...COLUNAS_TABELA_PADRAO],
        }),
        criarSlideVazio('tabela', {
            titulo: 'Sem fim previsto',
            fonte: 'dinamica',
            fonteDados: 'sem-fim',
            colunas: [...COLUNAS_TABELA_PADRAO],
        }),
        criarSlideVazio('texto', {
            titulo: 'Prioridades e deliberações',
            corpo: '',
            fonte: 'manual',
        }),
    ]
}

export function carregarApresentacao(userId) {
    try {
        const raw = localStorage.getItem(chaveStorageApresentacao(userId))
        if (!raw) return null
        const parsed = JSON.parse(raw)
        if (!parsed || parsed.version !== STORAGE_VERSION || !Array.isArray(parsed.slides)) {
            return null
        }
        parsed.slides = normalizarSlidesApresentacao(parsed.slides)
        return parsed
    } catch {
        return null
    }
}

export function salvarApresentacao(userId, config) {
    const payload = {
        version: STORAGE_VERSION,
        slides: normalizarSlidesApresentacao(config.slides || []),
    }
    localStorage.setItem(chaveStorageApresentacao(userId), JSON.stringify(payload))
}

export function obterOuCriarApresentacao(userId, contextoPeriodo) {
    const salva = carregarApresentacao(userId)
    if (salva?.slides?.length) return salva
    return {
        version: STORAGE_VERSION,
        slides: criarSlidesPadrao(contextoPeriodo),
    }
}

export function validarImagemUpload(file) {
    if (!file) return { ok: false, erro: 'Nenhum arquivo selecionado.' }
    if (!IMAGEM_TIPOS_PERMITIDOS.includes(file.type)) {
        return { ok: false, erro: 'Use PNG, JPG ou WebP.' }
    }
    if (file.size > IMAGEM_MAX_BYTES) {
        return { ok: false, erro: 'Imagem muito grande (máx. 2 MB).' }
    }
    return { ok: true }
}

export function lerArquivoComoDataUrl(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => resolve(reader.result)
        reader.onerror = () => reject(new Error('Falha ao ler a imagem.'))
        reader.readAsDataURL(file)
    })
}

function normalizarProjetoApi(projeto) {
    if (!projeto) return null
    return {
        projeto_id: Number(projeto.id),
        pcm_codigo: projeto.pcm_codigo || projeto.pcm?.codigo || '',
        projeto_nome: projeto.nome || '',
        projeto_status: projeto.status || '',
        gerente_nome: projeto.gerente?.name || projeto.gerente || '',
        nome: projeto.nome || '',
        status: projeto.status || '',
        dtInicio: projeto.dtInicio || null,
        dtTermino: projeto.dtTermino || null,
        setor: projeto.setor?.nome || projeto.setor || '',
    }
}

function listaPorFonteDados(fonteDados, contexto) {
    const mapa = {
        'entregas-periodo': contexto.entregasExibidas || [],
        fixadas: contexto.fixadasExibidas || [],
        atrasadas: contexto.atrasadasExibidas || [],
        'sem-fim': contexto.semFimExibidas || [],
    }
    return mapa[fonteDados] || []
}

function colunasSaoSomenteProjeto(colunas = []) {
    if (!colunas.length) return false
    return !colunasPrecisamEntrega(colunas)
}

function deduplicarPorProjeto(entregas) {
    const vistos = new Set()
    const resultado = []
    for (const e of entregas) {
        const pid = Number(e.projeto_id)
        if (vistos.has(pid)) continue
        vistos.add(pid)
        resultado.push(e)
    }
    return resultado
}

export function obterValorColuna(item, campo) {
    if (!item) return '—'
    const meta = CATALOGO_COLUNAS[campo]
    let valor = item[campo]

    if (campo === 'projeto_nome' && (valor == null || valor === '')) {
        valor = item.nome
    }
    if (campo === 'projeto_status' && (valor == null || valor === '')) {
        valor = item.status
    }
    if (campo === 'gerente_nome' && (valor == null || valor === '')) {
        valor = typeof item.gerente === 'object' ? item.gerente?.name : item.gerente
    }

    if (valor == null || valor === '') return '—'

    if (meta?.formatar === 'data') {
        return formatarDataBr(String(valor).slice(0, 10))
    }
    if (meta?.formatar === 'boolean') {
        return valor ? 'Sim' : 'Não'
    }

    return String(valor)
}

function buscarEntregaNoPainel(entregaId, contexto) {
    const eid = Number(entregaId)
    if (!eid) return null
    if (contexto.entregasPorEntregaId?.[eid]) return contexto.entregasPorEntregaId[eid]
    const listas = [
        contexto.entregasExibidas,
        contexto.fixadasExibidas,
        contexto.atrasadasExibidas,
        contexto.semFimExibidas,
    ]
    for (const lista of listas) {
        const encontrada = (lista || []).find((e) => Number(e.entrega_id) === eid)
        if (encontrada) return encontrada
    }
    return null
}

function resolverItemManual(item, contexto) {
    const projetoId = Number(item.projeto_id)
    const entregaId = item.entrega_id != null ? Number(item.entrega_id) : null
    const cacheProjeto = contexto.cacheProjetos?.[projetoId]
    const fallbackProjeto = contexto.entregasPorProjetoId?.[projetoId]

    if (entregaId) {
        const doCache = contexto.cacheEntregas?.[entregaId]
        const doPainel = buscarEntregaNoPainel(entregaId, contexto)
        const linha = doCache || doPainel
        if (linha) {
            return {
                ...linha,
                projeto_id: projetoId,
                pcm_codigo: linha.pcm_codigo || cacheProjeto?.pcm_codigo || fallbackProjeto?.pcm_codigo,
                projeto_nome: linha.projeto_nome || cacheProjeto?.projeto_nome || fallbackProjeto?.projeto_nome,
                projeto_status: linha.projeto_status || cacheProjeto?.projeto_status || fallbackProjeto?.projeto_status,
                gerente_nome: linha.gerente_nome || cacheProjeto?.gerente_nome || fallbackProjeto?.gerente_nome,
            }
        }
    }

    if (cacheProjeto) return { ...cacheProjeto }
    if (fallbackProjeto) return { ...fallbackProjeto }
    if (projetoId > 0) {
        return {
            projeto_id: projetoId,
            projeto_nome: `Projeto #${projetoId}`,
        }
    }
    return null
}

export function resolverLinhasSlide(slide, contexto) {
    if (slide.tipo !== 'tabela') return []

    if (slide.fonte === 'dinamica') {
        let linhas = listaPorFonteDados(slide.fonteDados, contexto)
        if (colunasSaoSomenteProjeto(slide.colunas)) {
            linhas = deduplicarPorProjeto(linhas)
        }
        return linhas
    }

    const slideNorm = normalizarSlideManual({ ...slide })
    return (slideNorm.itensManuais || [])
        .map((item) => resolverItemManual(item, contexto))
        .filter(Boolean)
}

export function resolverSlide(slide, contexto) {
    const periodo = labelPeriodoSemana(contexto.periodoInicio, contexto.periodoFim)
    const hoje = formatarDataBr(new Date().toISOString().slice(0, 10))

    if (slide.tipo === 'capa') {
        return {
            ...slide,
            subtituloExibido: slide.subtitulo || periodo || hoje,
        }
    }

    if (slide.tipo === 'texto') {
        const bullets = (slide.corpo || '')
            .split('\n')
            .map((l) => l.trim())
            .filter(Boolean)
        return { ...slide, bullets }
    }

    if (slide.tipo === 'tabela') {
        const linhas = resolverLinhasSlide(slide, contexto)
        const colunas = (slide.colunas || []).map((c) => ({
            campo: c,
            label: labelColuna(c),
        }))
        return {
            ...slide,
            linhas,
            colunas,
            fonteDadosLabel: slide.fonte === 'dinamica' ? labelFonteDados(slide.fonteDados) : null,
        }
    }

    return { ...slide }
}

export function resolverSlidesParaExportacao(config, contexto) {
    return (config.slides || []).map((slide) => resolverSlide(slide, contexto))
}

export function montarCacheProjetos(projetosApi = []) {
    const cache = {}
    for (const p of projetosApi) {
        const norm = normalizarProjetoApi(p)
        if (norm?.projeto_id) cache[norm.projeto_id] = norm
    }
    return cache
}

export function montarEntregasPorProjetoId(entregasListas = []) {
    const mapa = {}
    for (const lista of entregasListas) {
        for (const e of lista || []) {
            const pid = Number(e.projeto_id)
            if (!pid) continue
            if (!mapa[pid]) {
                mapa[pid] = {
                    projeto_id: pid,
                    pcm_codigo: e.pcm_codigo,
                    projeto_nome: e.projeto_nome,
                    projeto_status: e.projeto_status,
                    gerente_nome: e.gerente_nome,
                }
            }
        }
    }
    return mapa
}

export function montarEntregasPorEntregaId(entregasListas = []) {
    const mapa = {}
    for (const lista of entregasListas) {
        for (const e of lista || []) {
            const eid = Number(e.entrega_id)
            if (eid) mapa[eid] = e
        }
    }
    return mapa
}

export function normalizarEntregaApi(projetoApi, entregaApi) {
    if (!entregaApi) return null
    const projeto = normalizarProjetoApi(projetoApi)
    const pcm = projetoApi?.pcm
    return {
        entrega_id: Number(entregaApi.id),
        projeto_id: projeto?.projeto_id || Number(entregaApi.projeto_id),
        pcm_codigo: projeto?.pcm_codigo || pcm?.codigo || '',
        projeto_nome: projeto?.projeto_nome || projetoApi?.nome || '',
        projeto_status: projeto?.projeto_status || projetoApi?.status || '',
        gerente_nome: projeto?.gerente_nome || '',
        entrega_nome: entregaApi.nome || '',
        coordenador_nome: entregaApi.coordenador?.name || '',
        fim_previsto: entregaApi.dtFim || null,
        entrega_status: entregaApi.status || '',
        dt_inicio: entregaApi.dtInicio || null,
        dt_conclusao: entregaApi.dt_conclusao || null,
        observacao: entregaApi.observacao || '',
        resultado_ser_alcancado: entregaApi.resultado_ser_alcancado || '',
        resultado_alcancado: entregaApi.resultado_alcancado || '',
        nome: projeto?.projeto_nome || projetoApi?.nome || '',
        status: projeto?.projeto_status || projetoApi?.status || '',
        dtInicio: projeto?.dtInicio || projetoApi?.dtInicio || null,
        dtTermino: projeto?.dtTermino || projetoApi?.dtTermino || null,
        setor: projeto?.setor || '',
    }
}

export function montarCacheEntregasDeProjeto(projetoApi) {
    const cache = {}
    if (!projetoApi) return cache
    for (const entrega of projetoApi.entregas || []) {
        const norm = normalizarEntregaApi(projetoApi, entrega)
        if (norm?.entrega_id) cache[norm.entrega_id] = norm
    }
    return cache
}

export const LABEL_FONTE_DADOS = {
    'entregas-periodo': 'Pacotes de trabalho no período',
    fixadas: 'Pacotes de trabalho fixados',
    atrasadas: 'Pacotes de trabalho atrasados',
    'sem-fim': 'Sem fim previsto',
}

export const OPCOES_FONTE_DADOS = [
    { value: 'entregas-periodo', label: LABEL_FONTE_DADOS['entregas-periodo'] },
    { value: 'atrasadas', label: LABEL_FONTE_DADOS.atrasadas },
    { value: 'fixadas', label: LABEL_FONTE_DADOS.fixadas },
    { value: 'sem-fim', label: LABEL_FONTE_DADOS['sem-fim'] },
]

export function tituloPadraoFonteDados(fonteDados) {
    return LABEL_FONTE_DADOS[fonteDados] || 'Nova tabela'
}

export function tituloDeveSincronizarComFonte(titulo) {
    const t = (titulo || '').trim()
    if (!t) return true
    if (t === 'Nova tabela' || t === 'Tabela personalizada') return true
    return Object.values(LABEL_FONTE_DADOS).includes(t)
}

export function labelFonteDados(fonteDados) {
    return LABEL_FONTE_DADOS[fonteDados] || fonteDados || ''
}

export const TIPOS_SLIDE_LABEL = {
    capa: 'Capa',
    texto: 'Texto',
    tabela: 'Tabela',
    imagem: 'Imagem',
}
